<div class="dialog-container" [dir]="languageService.getDirection()">
  <!-- Header avec icône -->
  <div class="dialog-header" [class]="'type-' + data.type">
    <mat-icon *ngIf="data.showIcon" class="dialog-icon">{{ getIcon() }}</mat-icon>
    <h2 class="dialog-title" [innerHTML]="data.title | translate"></h2>
  </div>

  <!-- Contenu -->
  <div class="dialog-content">
    <p class="dialog-message" [innerHTML]="data.message | translate"></p>
  </div>

  <!-- Actions -->
  <div class="dialog-actions">
    <button 
      mat-button 
      class="cancel-button"
      (click)="onCancel()">
      <mat-icon>close</mat-icon>
      {{ data.cancelText | translate }}
    </button>
    
    <button 
      mat-raised-button 
      class="confirm-button"
      [class]="'button-' + data.type"
      (click)="onConfirm()">
      <mat-icon>check</mat-icon>
      {{ data.confirmText | translate }}
    </button>
  </div>
</div>
